









import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import WalletTable from '@wallet/components/tables/wallet-table.vue';

@Component({
  name: 'bpc-wallets',
  components: {
    'bpc-wallet-table': WalletTable,
  },
})
export default class Wallets extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
